module.exports = __webpack_public_path__ + "abb5eff0b28369c30456b07790511ee2.png";